<div class="element" *ngIf="!item.separator" (mousedown)="selectItem()" [ngClass]="[design, isActive() ? 'active' : '', isDisabled() ? 'disabled' : '']" [ngStyle]="{'max-width.px': maxWidth}" >
    <span class="icon" [ngClass]="[item.icon ? item.icon : '']"></span>
    <span class="title" [ngClass]="{'with-icon': item.icon}" [ngStyle]="{'color': item.color}">{{ item.title }}</span>
    <span class="icon-Valider" [ngClass]="{'hidden-icon': !isSelected()}"></span>
</div>

<div class="separator" *ngIf="item.separator"></div>
